import React from "react";
import SignUpComponent from "../components/SignUpComponent.js";

class signup extends React.Component {
  render() {
    return (
        <div>
          <SignUpComponent />
        </div>
    )
  }
}

export default signup;
